import classnames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip/tooltip';
import { Placement } from 'swag-client-common/constants';
import React from 'react';
import { Color } from 'swag-client-common/components/ui/color';
import classes from './view-colors-tooltip.scss';
const viewColorsTooltipClasses = {
  popper: classes.viewColorsPopper,
  tooltip: classes.viewColorsTooltip
};
const ViewColorsTooltip = ({
  isShown,
  tooltipData,
  children,
  className,
  onClick,
  disableTouchListener = false
}) => {
  if (!isShown) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Tooltip, {
    interactive: true,
    "data-block": "ViewColors",
    title: tooltipData.map(({
      color,
      name,
      quantitiesData
    }) => /*#__PURE__*/React.createElement("div", {
      "data-row": name,
      key: color,
      className: classes.tooltipContentRow
    }, /*#__PURE__*/React.createElement(Color, {
      key: color,
      name: name,
      color: color,
      isActionable: false,
      className: classes.color
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.tooltipQuantityData
    }, quantitiesData.map(({
      size,
      quantity
    }, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      }, size ? /*#__PURE__*/React.createElement(React.Fragment, null, size, "\xA0-\xA0", quantity, quantitiesData[index + 1] && ', ') : quantity, "\xA0");
    })))),
    placement: Placement.RIGHT,
    mode: "light",
    className: classnames(classes.viewColorsTooltipWrapper, className),
    classes: viewColorsTooltipClasses,
    disableTouchListener: disableTouchListener
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.viewColors,
    onClick: onClick
  }, children || 'View Colors'));
};
export default ViewColorsTooltip;